export default __webpack_public_path__ + "static/media/full1.61fddf44.png";